module.exports = __webpack_public_path__ + "img/img_assistant_phone_img4.40683c2b.png";